import React, { useState, useRef } from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory, { PaginationProvider, PaginationListStandalone } from "react-bootstrap-table2-paginator";
import { MessageEmtyData } from "@ui-partents/Message";
import { useDispatch, useSelector } from "react-redux";
import { shareReference } from "@actions";

//apiCaller
import { apiCaller } from "@utils";

//constants
import { teachV2Constants } from "@constants";

//Icon
import { Icon } from '@components/common';
import More from '@images/teachV2/more-vertical.svg';

//Elements
import { LogoBox, FileNameContainer, AuthorJournalDisplay } from "../ReferenceLiblary/ReferenceElements";

//elements
import { WrapModalDeleteCommon } from "@ui-partents/Modal";
import { SortCaret } from "@ui-partents/Table";
import { TagsToolTip } from "@ui-partents/Tags";

//utils
import { LoaderText } from "@utils";

//components
import {
  UploadFileSuggestion,
  WrapModalEdit,
  ModalUploadReferenceDocument,
  AddNewReferenceDropdown
} from "../ReferenceLiblary";

//components
import { StatusField } from "@ui-partents/Button";
import { toast } from 'react-toastify';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';

// Import the pagination configuration
import { paginationOptions } from "@utils";

const ReferenceLibraryWrap = (props) => {
  const { loadDataReferenceBook, listValue, setListValue, inputValue, setInputValue } = props;
  const { SearchBar } = Search;
  const dispatch = useDispatch();
  const { dataFilter: documents, isLoading } = useSelector((state) => state.getReferenceBook) || {};
  const [modal, setModal] = useState({
    uploadDocument: false,
  });
  const isSearchingOrPaging = useRef(false);

  const handleShareReference = async (data) => {
    const dataShare = await dispatch(shareReference({
      "Action": "Share",
      "Target": "Organization",
      "ReferenceId": data?.document_id
    }))
    if (dataShare?.data?.status === 200) {
      toast.success('Successfully shared to Organization References', {
        position: "bottom-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      loadDataReferenceBook()
      setListValue([])
    }
  }

  const handleUnshareReference = async (data) => {
    const dataShare = await dispatch(shareReference({
      "Action": "Unshare",
      "Target": "Organization",
      "ReferenceId": data?.document_id
    }))
    if (dataShare?.data?.status === 200) {
      toast.success('Successfully unshared from Organization References', {
        position: "bottom-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      loadDataReferenceBook()
      setListValue([])
    }
  }

  //toggle
  const toggle = (type, value = null) => {
    setModal((prevState) => ({ ...prevState, [type]: !prevState[type] }));
  };

  // Handle Remove Document
  const handleRemoveDocument = (document_id) => {
    if (document_id) {
      const params = {
        "action_type": "delete_uploaded_document",
        "document_id": document_id
      };

      const isLoading = true;
      dispatch({ type: teachV2Constants.DELETE_RAG_DOCUMENT_REQUEST, isLoading });

      apiCaller(`/api/medicalcase/functional/`, 'POST', params)
        .then(res => {
          if (res?.data) {
            dispatch({ type: teachV2Constants.DELETE_RAG_DOCUMENT_SUCCESS, payload: res.data });
            loadDataReferenceBook()
            setListValue([])
          } else {
            const error = "error";
            dispatch({ type: teachV2Constants.DELETE_RAG_DOCUMENT_FAILURE, error });
          }
        })
        .catch(err => {
          const errorMessage = err.message || "API call failed";
          dispatch({ type: teachV2Constants.DELETE_RAG_DOCUMENT_FAILURE, error: errorMessage });
        })
        .finally(() => {
        });
    }
  };

  const componentsCommon = {
    DropdownIndicator: () => null,
    IndicatorSeparator: () => null,
    MultiValueContainer: (props) => {
      return (
        <div className="custom-tag">
          <components.MultiValueContainer {...props} />
        </div>
      );
    }
  };

  const handleAddTag = (value) => {
    setListValue(value)
  }

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setListValue((prev) => prev ? [...prev, createOption(inputValue)] : [createOption(inputValue)]);
        setInputValue('');
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  const columns = [
    {
      dataField: "source_logo_url",
      text: "Source",
      headerStyle: { width: "107px" },
      headerClasses: 'align-middle text-center',
      formatter: (cell, row) => {
        return (
          <LogoBox backgroundImage={cell} />
        );
      },
    },
    {
      dataField: "title",
      text: "Title",
      headerClasses: 'align-middle text-left',
      headerStyle: { width: "500px" },
      sort: true,
      sortCaret: (order, column) => <SortCaret order={order} />,
      formatter: (cell, row) => {
        return (
          <FileNameContainer row={row} />
        );
      },
    },
    {
      dataField: "Author",
      text: "Author(s)",
      headerClasses: 'text-nowrap align-middle text-left',
      headerStyle: { width: "300px" },
      formatter: (cell, row) => {
        return (
          <AuthorJournalDisplay 
            authorList = {row.author_list}
            journalCitation = {row.journal_citation}
          />
        );
      },
    },
    {
      dataField: "year",
      text: " Year",
      headerClasses: 'text-nowrap align-middle text-center',
      headerStyle: { width: "99px" },
      formatter: (cell, row) => {
        return (
          <div>{cell}</div>
        );
      },
    },
    {
      Field: "tags",
      text: "Tag(s)",
      headerClasses: "align-middle text-center",
      headerStyle: { width: "168px" },
      formatter: (cell, row) => {
        return (
          <TagsToolTip
            tags={row?.tags}
            documentId={row?.document_id}
            color={'blue'}
          />
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerClasses: "align-middle text-center",
      headerStyle: { width: "80px" },
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center justify-content-center">
            <StatusField status={row?.status} row={row} />
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "Action",
      headerClasses: "align-middle text-center",
      headerStyle: { width: "79px" },
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center justify-content-center action-reference">
            <Icon src={More} />
            <div className="action-reference__list">
              {row?.status?.color !== "warning" && (
                !row?.shared_to_institution ? (
                  <p onClick={() => handleShareReference(row)}>Share to Organization</p>
                ) : (
                  <p onClick={() => handleUnshareReference(row)}>Unshare</p>
                )
              )}
              <WrapModalEdit
                title="Edit Reference Document"
                currentItem={row}
                createOption={createOption}
                setListValueFilter={setListValue}
                {...props}
              >
                {({ onOpen }) => (
                  <p onClick={onOpen}>Edit</p>
                )}
              </WrapModalEdit>
              <WrapModalDeleteCommon
                title={`Delete Document`}
                sub={`Are you sure you want to delete this document? This action cannot be undone.`}
                handleRemove={handleRemoveDocument}
                idRemove={row?.document_id}
              >
                {({ onOpen }) => (
                  <p onClick={onOpen}>Delete</p>
                )}
              </WrapModalDeleteCommon>
            </div>
          </div>
        );
      },
    }
  ];

  const handleBlur = () => {
    if (inputValue) {
      setListValue((prev) => prev ? [...prev, createOption(inputValue)] : [createOption(inputValue)]);
    }
  }

  const contentTable = ({ paginationProps, paginationTableProps }) => (
    <ToolkitProvider keyField="document_id" data={documents?.MyReferences || []} columns={columns} search>
      {(toolkitprops) => (
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <div className='tb-heading-total'>Total Documents: {documents?.MyReferences?.length}</div>
            <div className='d-flex align-items-center'>
              <div className="boxSearch">
                <SearchBar
                  {...toolkitprops.searchProps}
                  onSearch={(e) => {
                    paginationProps.page = 1;
                    toolkitprops.searchProps.onSearch(e);
                    isSearchingOrPaging.current = false;
                  }}
                  onKeyUp={() => { isSearchingOrPaging.current = true; }}
                />
              </div>
              <div className="email-share__form-input ml-2">
                <CreatableSelect
                  components={componentsCommon}
                  inputValue={inputValue}
                  isClearable
                  isMulti
                  menuIsOpen={false}
                  onChange={(newValue) => {
                    handleAddTag(newValue)
                  }
                  }
                  onInputChange={(newValue) => {
                    setInputValue(newValue)
                  }}
                  onKeyDown={(e) => {
                    paginationProps.onPageChange(1, 10);
                    handleKeyDown(e)
                  }}
                  onBlur={handleBlur}
                  placeholder="Filter by Tags"
                  value={listValue}
                  classNamePrefix={`filter-tag`}
                />
              </div>
              <AddNewReferenceDropdown
                {...props}
              />
            </div>
          </div>
          <BootstrapTable
            condensed
            wrapperClasses="table-custom-common table-responsive mt-4"
            bordered={false}
            data={documents?.MyReferences}
            columns={columns}
            noDataIndication={() => (
              <MessageEmtyData
                title="No Results Found"
                text="Sorry, we couldn't find any matches for your search. Please try adjusting your search terms or using different keywords."
              />
            )}
            {...paginationTableProps}
            {...toolkitprops.baseProps}
          />
          <div className="pagination-custom-case d-flex justify-content-end ml-4">
            <PaginationListStandalone {...paginationProps} />
          </div>
        </div>
      )}
    </ToolkitProvider>
  );

  // Extract the total size from documents dynamically
  const totalSize = documents?.MyReferences?.length || 0;

  // Use the paginationOptions function to configure pagination settings
  const paginationConfig = paginationOptions({ totalSize });
  
  return (
    <React.Fragment>
      <div className={`table-refer bg-white ${documents?.MyReferences?.length === 0 ? 'position-relative' : ''}`} style={{ height: documents?.MyReferences?.length === 0 ? 'calc(100vh - 72px)' : 'auto' }}>
        {isLoading ? (
          <LoaderText />
        ) : (
          (documents?.MyReferences?.length > 0 || listValue?.length > 0) &&
          <PaginationProvider pagination={paginationFactory(paginationConfig)}>
            {contentTable}
          </PaginationProvider>
        )}
        {documents?.MyReferences?.length === 0 && !isLoading && listValue?.length === 0 && (
          <UploadFileSuggestion
            title="Upload Your Reference Document"
            content="It looks like you haven't uploaded any reference documents yet. Click the ‘Upload Document’ button to add new reference materials."
            org={true}
            toggle={toggle}
            {...props}
          >
            <AddNewReferenceDropdown
              {...props}
            />
          </UploadFileSuggestion>
        )}
      </div>
      <ModalUploadReferenceDocument
        isOpen={modal.uploadDocument}
        toggleModal={() => toggle("uploadDocument")}
        title="Upload Reference Document"
        {...props}
      />
    </React.Fragment>
  );
};

export default ReferenceLibraryWrap;